/* ============================================================
   Pathway Select Premium Header
   File: assets/ps-header.js
   ============================================================ */

(function () {
  'use strict';

  function initHeader(root) {
    if (!root || root.dataset.psHeaderReady === 'true') return;
    root.dataset.psHeaderReady = 'true';

    var menuItems = Array.prototype.slice.call(root.querySelectorAll('[data-ps-menu-item]'));
    var drawer = root.querySelector('[data-ps-mobile-drawer]');
    var searchPanel = root.querySelector('[data-ps-search-panel]');
    var drawerOpeners = Array.prototype.slice.call(root.querySelectorAll('[data-ps-drawer-open]'));
    var drawerClosers = Array.prototype.slice.call(root.querySelectorAll('[data-ps-drawer-close]'));
    var searchOpeners = Array.prototype.slice.call(root.querySelectorAll('[data-ps-search-open]'));
    var searchClosers = Array.prototype.slice.call(root.querySelectorAll('[data-ps-search-close]'));
    var searchInput = root.querySelector('[data-ps-search-input]');
    var openTimer = null;
    var closeTimer = null;
    var lastFocused = null;

    function setBodyLock() {
      var open = Boolean(
        (drawer && drawer.classList.contains('is-open')) ||
        (searchPanel && searchPanel.classList.contains('is-open'))
      );
      document.body.classList.toggle('ps-header-lock', open);
    }

    function closeMenus(exceptItem) {
      menuItems.forEach(function (item) {
        if (item === exceptItem) return;
        item.classList.remove('is-open');
        var trigger = item.querySelector('[data-ps-menu-trigger]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        resetPreview(item);
      });
    }

    function openMenu(item) {
      if (!item) return;
      window.clearTimeout(closeTimer);
      closeMenus(item);
      item.classList.add('is-open');
      var trigger = item.querySelector('[data-ps-menu-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    }

    function closeMenu(item) {
      if (!item) return;
      item.classList.remove('is-open');
      var trigger = item.querySelector('[data-ps-menu-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      resetPreview(item);
    }

    function resetPreview(scope) {
      var mega = scope && scope.matches && scope.matches('[data-ps-mega]')
        ? scope
        : scope && scope.querySelector
          ? scope.querySelector('[data-ps-mega]')
          : null;

      if (!mega) return;

      var image = mega.querySelector('[data-ps-mega-image]');
      var story = mega.querySelector('[data-ps-story]');
      var heading = mega.querySelector('[data-ps-story-heading]');
      var subheading = mega.querySelector('[data-ps-story-subheading]');

      mega.querySelectorAll('[data-ps-preview-link]').forEach(function (link) {
        link.classList.remove('is-active-preview');
      });

      if (image) {
        var defaultSrc = image.getAttribute('data-ps-default-src');
        var defaultSrcset = image.getAttribute('data-ps-default-srcset');
        if (defaultSrc && image.getAttribute('src') !== defaultSrc) {
          swapImage(image, defaultSrc, defaultSrcset);
        }
      }

      if (story && heading && subheading) {
        updateStory(
          story,
          heading,
          subheading,
          story.getAttribute('data-ps-default-heading') || '',
          story.getAttribute('data-ps-default-subheading') || ''
        );
      }
    }

    function swapImage(image, src, srcset) {
      if (!image || !src) return;
      image.classList.add('is-switching');

      window.setTimeout(function () {
        image.src = src;
        if (srcset) {
          image.srcset = srcset;
        } else {
          image.removeAttribute('srcset');
        }

        if (image.complete) {
          image.classList.remove('is-switching');
        } else {
          image.addEventListener('load', function handleLoad() {
            image.classList.remove('is-switching');
          }, { once: true });
        }
      }, 90);
    }

    function updateStory(story, heading, subheading, nextHeading, nextSubheading) {
      if (!story || !heading || !subheading) return;

      if (
        heading.textContent === nextHeading &&
        subheading.textContent === nextSubheading
      ) return;

      story.classList.add('is-switching');

      window.setTimeout(function () {
        heading.textContent = nextHeading || '';
        subheading.textContent = nextSubheading || '';
        story.classList.remove('is-switching');
      }, 80);
    }

    function activatePreview(link) {
      var mega = link.closest('[data-ps-mega]');
      if (!mega) return;

      var image = mega.querySelector('[data-ps-mega-image]');
      var story = mega.querySelector('[data-ps-story]');
      var heading = mega.querySelector('[data-ps-story-heading]');
      var subheading = mega.querySelector('[data-ps-story-subheading]');
      var previewSrc = link.getAttribute('data-ps-preview-src');
      var previewSrcset = link.getAttribute('data-ps-preview-srcset');
      var previewHeading = link.getAttribute('data-ps-preview-heading');
      var previewSubheading = link.getAttribute('data-ps-preview-subheading');

      mega.querySelectorAll('[data-ps-preview-link]').forEach(function (candidate) {
        candidate.classList.toggle('is-active-preview', candidate === link);
      });

      if (image && previewSrc) {
        swapImage(image, previewSrc, previewSrcset);
      }

      if (story && heading && subheading && (previewHeading || previewSubheading)) {
        updateStory(
          story,
          heading,
          subheading,
          previewHeading || story.getAttribute('data-ps-default-heading') || '',
          previewSubheading || story.getAttribute('data-ps-default-subheading') || ''
        );
      }
    }

    menuItems.forEach(function (item) {
      var trigger = item.querySelector('[data-ps-menu-trigger]');
      var mega = item.querySelector('[data-ps-mega]');
      if (!trigger || !mega) return;

      item.addEventListener('mouseenter', function () {
        window.clearTimeout(openTimer);
        window.clearTimeout(closeTimer);
        openTimer = window.setTimeout(function () {
          openMenu(item);
        }, 90);
      });

      item.addEventListener('mouseleave', function () {
        window.clearTimeout(openTimer);
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(function () {
          closeMenu(item);
        }, 130);
      });

      item.addEventListener('focusin', function () {
        openMenu(item);
      });

      item.addEventListener('focusout', function (event) {
        if (!item.contains(event.relatedTarget)) {
          closeMenu(item);
        }
      });

      trigger.addEventListener('click', function (event) {
        if (window.matchMedia('(min-width: 901px)').matches && !item.classList.contains('is-open')) {
          event.preventDefault();
          openMenu(item);
        }
      });

      mega.querySelectorAll('[data-ps-preview-link]').forEach(function (link) {
        link.addEventListener('mouseenter', function () {
          activatePreview(link);
        });

        link.addEventListener('focus', function () {
          activatePreview(link);
        });
      });

      mega.addEventListener('mouseleave', function () {
        resetPreview(mega);
      });
    });

    function openDrawer() {
      if (!drawer) return;
      lastFocused = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      drawerOpeners.forEach(function (button) {
        button.setAttribute('aria-expanded', 'true');
      });
      setBodyLock();

      var closeButton = drawer.querySelector('[data-ps-drawer-close]');
      if (closeButton) window.setTimeout(function () { closeButton.focus(); }, 30);
    }

    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      drawerOpeners.forEach(function (button) {
        button.setAttribute('aria-expanded', 'false');
      });
      setBodyLock();
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    function openSearch() {
      if (!searchPanel) return;
      closeDrawer();
      lastFocused = document.activeElement;
      searchPanel.classList.add('is-open');
      searchPanel.setAttribute('aria-hidden', 'false');
      searchOpeners.forEach(function (button) {
        button.setAttribute('aria-expanded', 'true');
      });
      setBodyLock();
      if (searchInput) window.setTimeout(function () { searchInput.focus(); }, 50);
    }

    function closeSearch() {
      if (!searchPanel) return;
      searchPanel.classList.remove('is-open');
      searchPanel.setAttribute('aria-hidden', 'true');
      searchOpeners.forEach(function (button) {
        button.setAttribute('aria-expanded', 'false');
      });
      setBodyLock();
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    drawerOpeners.forEach(function (button) {
      button.addEventListener('click', openDrawer);
    });

    drawerClosers.forEach(function (button) {
      button.addEventListener('click', closeDrawer);
    });

    searchOpeners.forEach(function (button) {
      button.addEventListener('click', openSearch);
    });

    searchClosers.forEach(function (button) {
      button.addEventListener('click', closeSearch);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      closeMenus();
      closeDrawer();
      closeSearch();
    });

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) closeMenus();
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth > 900) closeDrawer();
    });

    document.addEventListener('shopify:block:select', function (event) {
      if (!root.contains(event.target)) return;
      var mega = event.target.closest('[data-ps-mega]');
      if (!mega) return;
      var item = mega.closest('[data-ps-menu-item]');
      if (item) openMenu(item);
    });

    document.addEventListener('shopify:block:deselect', function (event) {
      if (!root.contains(event.target)) return;
      closeMenus();
    });
  }

  function initialiseAll() {
    document.querySelectorAll('[data-ps-header-section]').forEach(initHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseAll);
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-ps-header-section]');
    if (root) initHeader(root);
  });
})();